import { getHostApis } from '../getHost'

export function setProfileProperty(name: string, value: object | string): void {
  const { shift, chrome, onelaunch } = getHostApis()

  const shiftAPI = shift?.analytics?.setProfileProperties
  if (shiftAPI) {
    return shiftAPI({ [name]: value })
  }

  // Only stringify objects, pass strings as is
  const serializedValue =
    typeof value === 'string' ? value : JSON.stringify(value)

  const oneLaunchAPI = onelaunch?.setProfileProperty
  if (oneLaunchAPI) {
    oneLaunchAPI(name, serializedValue)
    return
  }

  const chromeAPI = chrome?.runtime?.setProfileProperty
  if (chromeAPI) {
    chromeAPI(name, serializedValue)
  }
}
